import { render, staticRenderFns } from "./ProductReviews.vue?vue&type=template&id=963453ce&scoped=true&"
import script from "./ProductReviews.vue?vue&type=script&lang=js&"
export * from "./ProductReviews.vue?vue&type=script&lang=js&"
import style0 from "./ProductReviews.vue?vue&type=style&index=0&id=963453ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963453ce",
  null
  
)

export default component.exports